import IconBase from "./IconBase";

// Angle brackets around a slash.
const CodeIcon = (props) => (
    <IconBase {...props}>
        <path d="M8.5 7.5L4 12l4.5 4.5" />
        <path d="M15.5 7.5L20 12l-4.5 4.5" />
        <path d="M13.5 5.5l-3 13" />
    </IconBase>
);

export default CodeIcon;
